<template>
    <div class="d-flex flex-column flex-root">
        <div class="d-flex flex-column flex-column-fluid">
            <div class="d-flex flex-column flex-column-fluid text-center p-10 py-lg-15">
                <a href="#" class="pt-lg-10">
                    <img alt="Logo" :src="'/admin/images/logo_mostra.png'" class="h-100px" />
                </a>
                <div class="pt-lg-10 mb-10">
                    <h1 class="fw-bolder fs-2qx text-gray-800 mb-7">Verifique o seu e-mail</h1>
                    <div class="fs-3 fw-bold text-muted mb-10">Enviamos um link de verificação para o e-mail cadastrado.
                        <br />Essa etapa é necessária para confirmarmos sua identidade :)</div>

                    <div class="fs-5">
                        <span class="fw-bold text-gray-700">Não recebeu o e-mail ? </span>
                        <a href="../../demo1/dist/authentication/flows/basic/sign-up.html" class="link-primary fw-bolder">Enviar novamente</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import FooterAuth from "./FooterAuth";
import App from "../Layouts/App";
export default {
    components: {App, FooterAuth}
}
</script>
